(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["track-order"]) return;
  try {
    
document.querySelectorAll('[data-track]').forEach(function (f) {
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var o = f.order.value.trim(), p = f.phone.value.trim();
    var msg = 'Hola, quiero saber el estado de mi pedido #' + o + '. Celular: ' + p;
    var n = f.dataset.wa;
    window.location.href = n ? 'https://wa.me/' + n + '?text=' + encodeURIComponent(msg) : '/pages/contacto';
  });
});

  } catch(e) { console.error(e); }
})();
})();
